module.exports = __webpack_public_path__ + "assets/img/2207.b70095a0.png";